// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"130":"75de27d2","305":"144f3d6b","350":"0f33454e","725":"fd5c6ffe","912":"39eeca4f","950":"99ed314e","992":"dfd7a80c"}[chunkId] + ".chunk.js";
};